import { useEffect, useRef } from 'react';

export const useInvokeOnce = (fn: () => void, enabled = true) => {
  const hasInvoked = useRef(false);

  useEffect(() => {
    if (!enabled || hasInvoked.current) return;
    hasInvoked.current = true;
    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
};
